import { useSite } from "@/context/SiteContext";
import { useSeo, pageSeo, clinicSchema, physicianSchema, websiteSchema, graph } from "@/lib/seo";
import { Hero } from "@/components/home/Hero";
import { ConditionTiles } from "@/components/home/ConditionTiles";
import { MeetDoctor } from "@/components/home/MeetDoctor";
import { TreatmentPathway } from "@/components/home/TreatmentPathway";
import { WhyYoungSpine } from "@/components/home/WhyYoungSpine";
import { SpineFitBand } from "@/components/home/SpineFitBand";
import { FaqPreview } from "@/components/home/FaqPreview";
import { VisitClinic } from "@/components/home/VisitClinic";
import { PostureScroll } from "@/components/home/PostureScroll";

export default function Home() {
  const { settings, content } = useSite();
  useSeo({ ...pageSeo("/"), jsonLd: graph(clinicSchema(settings), physicianSchema(settings, content), websiteSchema()) });
  return (
    <>
      <Hero />
      <ConditionTiles />
      <MeetDoctor />
      <PostureScroll />
      <TreatmentPathway />
      <WhyYoungSpine />
      <SpineFitBand />
      <FaqPreview />
      <VisitClinic />
    </>
  );
}
